import _Modules from '../core/core--modules';
import _bundle from '../core/core--bundles';
import { _g } from '../core/core--base';

const { _bp } = _g;

export default new _Modules({
    name: 'Anchors Scroll',
    settings: {
        selector: null,
        offset: 0,
        offsetElement: null,
        offsetNudge: 0,
        duration: 500,
        breakpoint: null,
        breakpointDir: null,
        fireAs: 'bundle'
    },
    fn() {
        const _module = this;
        const { settings: s } = _module;
        const { fireAs } = s;

        function _hasBoundEvent(eventType, $el) {
            const eventObject = $._data($el[0], 'events');
            const eventBound = eventObject !== undefined;
            const hasEventType = !!(eventObject && typeof eventObject[eventType] !== 'undefined');
            return eventBound && hasEventType;
        }

        function _clickHandler(e) {
            const { offset, duration } = s;
            const $el = $(this);
            const hash = $el.attr('href');

            if (hash !== '') {
                // e.preventDefault();
                const elMatch = $(hash);
                const elMatchPositionTop = elMatch[0].getBoundingClientRect().top;
                const startPosition = window.pageYOffset;
                const distance = elMatchPositionTop - offset;
                let startTime = null;
                const animation = currentTime => {
                    if (startTime === null) startTime = currentTime;
                    const timeElapsed = currentTime - startTime;
                    const run = Math.easeInOutQuad(timeElapsed, startPosition, distance, duration);
                    window.scrollTo(0, run);
                    if (timeElapsed < duration) requestAnimationFrame(animation);
                };
                //        http://www.gizma.com/easing
                Math.easeInOutQuad = (t, b, c, d) => {
                    t /= d / 2;
                    if (t < 1) return (c / 2) * t * t + b;
                    t--;
                    return (-c / 2) * (t * (t - 2) - 1) + b;
                };
                // Animate at 60fps for nice animation
                requestAnimationFrame(animation);
            }
        }

        function _scrollTo(settings) {
            const { selector } = settings;
            $(selector).each(function() {
                const $el = $(this);
                if (!_hasBoundEvent('click', $el)) {
                    $el.on('click', _clickHandler);
                }
            });
        }

        function _unbindEvents(eventType, $el, handler) {
            if (_hasBoundEvent(eventType, $el)) {
                $el.off(eventType, handler);
            }
        }
        function fire() {
            const $el = $(s.selector);
            if ($el.length) {
                if (_bp.match(s.breakpoint, s.breakpointDir)) {
                    _scrollTo(s);
                } else {
                    _unbindEvents('click', $el, _clickHandler);
                }
            }
        }

        if (fireAs === 'bundle') {
            _bundle.add({
                name: 'Module: AnchorsScroll',
                event: ['on:BundleReady', 'on:ResizeEnd', 'on:PageUpdate'],
                weight: 600, // 1.
                fn() {
                    fire();
                }
            });
        }
        if (fireAs === 'async') fire();
    }
});
